var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageCreateReceta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 109,
    viewBox: "0 0 102 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5795 76.3922L80.277 43.147C77.8545 37.0612 74.242 33.6095 70.1195 33.3825C66.0395 33.1554 62.087 36.1983 59.0695 42.0116L50.9945 57.4988C49.2945 60.7688 46.872 62.7218 44.237 62.9488C41.5594 63.2213 38.8819 61.7226 36.7144 58.7705L35.7794 57.4988C32.7619 53.4568 29.0219 51.5038 25.1969 51.9126C21.3719 52.3213 18.0994 55.1372 15.9319 59.7243L8.57936 75.393C5.94436 81.0701 6.19936 87.6555 9.30186 93.0147C12.4044 98.3738 17.8019 101.598 23.7094 101.598H77.9395C83.6345 101.598 88.947 98.5555 92.092 93.4688C95.322 88.3822 95.832 81.9784 93.5795 76.3922Z",
    fill: "#E8C4A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6218 38.064C37.5554 38.064 43.9867 31.1912 43.9867 22.7131C43.9867 14.2351 37.5554 7.3623 29.6218 7.3623C21.6883 7.3623 15.2568 14.2351 15.2568 22.7131C15.2568 31.1912 21.6883 38.064 29.6218 38.064Z",
    fill: "#E8C4A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCreateReceta);
export default __webpack_public_path__ + "static/media/ImageCreateReceta.5ba509432d14401e00555e7c4dee210c.svg";
export { ForwardRef as ReactComponent };